import React, { useEffect, useState } from "react";
import { db } from "../firebaseConfig";
import { collection, addDoc, getDocs } from "firebase/firestore";
import "./Reconcile.css";

const Reconcile = () => {
  const [formData, setFormData] = useState({
    statementPeriodStart: "",
    statementPeriodEnd: "",
    startingBalance: "",
    endingBalance: "",
    deposits: [],
    withdrawals: [],
    bankFees: "",
    interestEarned: "",
    generalLedgerEntries: [],
    outstandingChecks: [],
    depositsInTransit: [],
    electronicTransactions: [],
    receipts: [],
    adjustments: [],
    canceledChecks: [],
    nsfChecks: [],
  });
  const [reconcileList, setReconcileList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchReconciliations = async () => {
      const reconcileRef = collection(db, "reconcile");
      const querySnapshot = await getDocs(reconcileRef);
      setReconcileList(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };

    fetchReconciliations();
  }, []);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleArrayInputChange = (e, field) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [field]: formData[field].map((item, index) =>
        index === parseInt(name) ? value : item
      ),
    });
  };

  const handleAddArrayItem = (field) => {
    setFormData({ ...formData, [field]: [...formData[field], ""] });
  };

  const handleRemoveArrayItem = (field, index) => {
    setFormData({
      ...formData,
      [field]: formData[field].filter((_, i) => i !== index),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await addDoc(collection(db, "reconcile"), formData);
      setFormData({
        statementPeriodStart: "",
        statementPeriodEnd: "",
        startingBalance: "",
        endingBalance: "",
        deposits: [],
        withdrawals: [],
        bankFees: "",
        interestEarned: "",
        generalLedgerEntries: [],
        outstandingChecks: [],
        depositsInTransit: [],
        electronicTransactions: [],
        receipts: [],
        adjustments: [],
        canceledChecks: [],
        nsfChecks: [],
      });
      const reconcileRef = collection(db, "reconcile");
      const querySnapshot = await getDocs(reconcileRef);
      setReconcileList(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    } catch (error) {
      console.error("Error submitting reconciliation:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="reconcile-container">
      <h2>Monthly Reconciliation</h2>
      <form className="form-container" onSubmit={handleSubmit}>
        <h3>Bank Statement</h3>
        <label>Statement Period Start:</label>
        <input type="date" name="statementPeriodStart" value={formData.statementPeriodStart} onChange={handleInputChange} required />
        <label>Statement Period End:</label>
        <input type="date" name="statementPeriodEnd" value={formData.statementPeriodEnd} onChange={handleInputChange} required />
        <label>Starting Balance:</label>
        <input type="number" name="startingBalance" value={formData.startingBalance} onChange={handleInputChange} required />
        <label>Ending Balance:</label>
        <input type="number" name="endingBalance" value={formData.endingBalance} onChange={handleInputChange} required />
        <label>Deposits and Credits:</label>
        {formData.deposits.map((deposit, index) => (
          <div key={index}>
            <input type="text" name={index} value={deposit} onChange={(e) => handleArrayInputChange(e, "deposits")} placeholder="Date, Amount, Description" />
            <button type="button" onClick={() => handleRemoveArrayItem("deposits", index)}>Remove</button>
          </div>
        ))}
        <button type="button" onClick={() => handleAddArrayItem("deposits")}>Add Deposit</button>
        <label>Withdrawals, Checks, and Debits:</label>
        {formData.withdrawals.map((withdrawal, index) => (
          <div key={index}>
            <input type="text" name={index} value={withdrawal} onChange={(e) => handleArrayInputChange(e, "withdrawals")} placeholder="Date, Amount, Check #, Description" />
            <button type="button" onClick={() => handleRemoveArrayItem("withdrawals", index)}>Remove</button>
          </div>
        ))}
        <button type="button" onClick={() => handleAddArrayItem("withdrawals")}>Add Withdrawal</button>
        <label>Bank Fees or Service Charges:</label>
        <input type="number" name="bankFees" value={formData.bankFees} onChange={handleInputChange} />
        <label>Interest Earned:</label>
        <input type="number" name="interestEarned" value={formData.interestEarned} onChange={handleInputChange} />
        <h3>Accounting Records</h3>
        <label>General Ledger Entries:</label>
        {formData.generalLedgerEntries.map((entry, index) => (
          <div key={index}>
            <input type="text" name={index} value={entry} onChange={(e) => handleArrayInputChange(e, "generalLedgerEntries")} placeholder="Entry Details" />
            <button type="button" onClick={() => handleRemoveArrayItem("generalLedgerEntries", index)}>Remove</button>
          </div>
        ))}
        <button type="button" onClick={() => handleAddArrayItem("generalLedgerEntries")}>Add Entry</button>
        <label>Outstanding Checks:</label>
        {formData.outstandingChecks.map((check, index) => (
          <div key={index}>
            <input type="text" name={index} value={check} onChange={(e) => handleArrayInputChange(e, "outstandingChecks")} placeholder="Check Details" />
            <button type="button" onClick={() => handleRemoveArrayItem("outstandingChecks", index)}>Remove</button>
          </div>
        ))}
        <button type="button" onClick={() => handleAddArrayItem("outstandingChecks")}>Add Check</button>
        <label>Deposits in Transit:</label>
        {formData.depositsInTransit.map((deposit, index) => (
          <div key={index}>
            <input type="text" name={index} value={deposit} onChange={(e) => handleArrayInputChange(e, "depositsInTransit")} placeholder="Deposit Details" />
            <button type="button" onClick={() => handleRemoveArrayItem("depositsInTransit", index)}>Remove</button>
          </div>
        ))}
        <button type="button" onClick={() => handleAddArrayItem("depositsInTransit")}>Add Deposit</button>
        <label>Electronic Transactions:</label>
        {formData.electronicTransactions.map((transaction, index) => (
          <div key={index}>
            <input type="text" name={index} value={transaction} onChange={(e) => handleArrayInputChange(e, "electronicTransactions")} placeholder="Transaction Details" />
            <button type="button" onClick={() => handleRemoveArrayItem("electronicTransactions", index)}>Remove</button>
          </div>
        ))}
        <button type="button" onClick={() => handleAddArrayItem("electronicTransactions")}>Add Transaction</button>
        <label>Receipts:</label>
        {formData.receipts.map((receipt, index) => (
          <div key={index}>
            <input type="text" name={index} value={receipt} onChange={(e) => handleArrayInputChange(e, "receipts")} placeholder="Receipt Details" />
            <button type="button" onClick={() => handleRemoveArrayItem("receipts", index)}>Remove</button>
          </div>
        ))}
        <button type="button" onClick={() => handleAddArrayItem("receipts")}>Add Receipt</button>
        <label>Adjustments:</label>
        {formData.adjustments.map((adjustment, index) => (
          <div key={index}>
            <input type="text" name={index} value={adjustment} onChange={(e) => handleArrayInputChange(e, "adjustments")} placeholder="Adjustment Details" />
            <button type="button" onClick={() => handleRemoveArrayItem("adjustments", index)}>Remove</button>
          </div>
        ))}
        <button type="button" onClick={() => handleAddArrayItem("adjustments")}>Add Adjustment</button>
        <h3>Additional Items</h3>
        <label>Canceled Checks:</label>
        {formData.canceledChecks.map((check, index) => (
          <div key={index}>
            <input type="text" name={index} value={check} onChange={(e) => handleArrayInputChange(e, "canceledChecks")} placeholder="Check Details" />
            <button type="button" onClick={() => handleRemoveArrayItem("canceledChecks", index)}>Remove</button>
          </div>
        ))}
        <button type="button" onClick={() => handleAddArrayItem("canceledChecks")}>Add Check</button>
        <label>NSF Checks:</label>
        {formData.nsfChecks.map((check, index) => (
          <div key={index}>
            <input type="text" name={index} value={check} onChange={(e) => handleArrayInputChange(e, "nsfChecks")} placeholder="Check Details" />
            <button type="button" onClick={() => handleRemoveArrayItem("nsfChecks", index)}>Remove</button>
          </div>
        ))}
        <button type="button" onClick={() => handleAddArrayItem("nsfChecks")}>Add Check</button>
        <div className="modal-buttons">
          <button type="submit" className="blue-button" disabled={isSubmitting}>Submit</button>
        </div>
      </form>

      <h2>Reconciliation List</h2>
      <div className="table-container">
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>Statement Period</th>
                <th>Starting Balance</th>
                <th>Ending Balance</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {reconcileList.map((reconcile) => (
                <tr key={reconcile.id}>
                  <td>{reconcile.statementPeriodStart} - {reconcile.statementPeriodEnd}</td>
                  <td>${reconcile.startingBalance}</td>
                  <td>${reconcile.endingBalance}</td>
                  <td>
                    <button className="detail-button">Details</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Reconcile;